module.exports = __webpack_public_path__ + "static/media/sunIcon.970006d9.svg";